module.exports = __webpack_public_path__ + "img/home_icon_1.22edeb20.png";